import { render, staticRenderFns } from "./chat-message-order-details.vue?vue&type=template&id=5eb3b7de&scoped=true"
import script from "./chat-message-order-details.vue?vue&type=script&lang=js"
export * from "./chat-message-order-details.vue?vue&type=script&lang=js"
import style0 from "./chat-message-order-details.vue?vue&type=style&index=0&id=5eb3b7de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb3b7de",
  null
  
)

export default component.exports